import React from 'react';
import { Tab, Tabs, withStyles } from '@material-ui/core';
import { connect } from 'react-redux';
import { useState } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import PeriodPositionsRouter from '../PeriodPositions/PeriodPositionsRouter';
import { styleWithCommonClasses, tabDisplays } from '../../../_constants/emparkConstants';
import __t from '../../../locales';
import PeriodChildListPage from './PeriodChildListPage';

const styles = styleWithCommonClasses({})

const PeriodChildContainer = props => {
    const [tab, setTab] = useState(0);

    const classes = props.classes;

    return (
        <PeriodPositionsRouter
            context={props.context}
            rate={props.rate}
            period={props.period}
        />
    )

    // return (
    //     <>
    //         <Tabs
    //             className={classNames(classes.tabPanel)}
    //             value={tab}
    //             onChange={(e, index) => {
    //                 setTab(index);
    //             }}
    //             indicatorColor="primary"
    //             textColor="primary"
    //             variant="fullWidth"
    //         >
    //             <Tab disabled={props.tabDisplay == tabDisplays.secondary && props.pageMode == 'edit'} value={0} key="pt-1" className={classNames(classes.tab)} label={__t('positions')}></Tab>
    //             <Tab disabled={props.tabDisplay == tabDisplays.secondary && props.pageMode == 'edit'} value={1} key="pt-2" className={classNames(classes.nTab)} label={__t('groups')}></Tab>
    //             <Tab disabled={props.tabDisplay == tabDisplays.secondary && props.pageMode == 'edit'} value={2} key="pt-3" className={classNames(classes.nTab)} label={__t('emission_profiles')}></Tab>
    //         </Tabs>
    //         {tab === 0 ?
    //             <PeriodPositionsRouter
    //                 context={props.context}
    //                 rate={props.rate}
    //                 period={props.period}
    //             />
    //             :
    //             <PeriodChildListPage
    //                 key={tab == 1 ? 'groups' : 'emission_profiles'}
    //                 type={tab == 1 ? 'groups' : 'emission_profiles'}
    //                 rateId={props.rate.id}
    //                 periodId={props.period.id}
    //             />
    //         }
    //     </>
    // );
}

PeriodChildContainer.propTypes = {
    context: PropTypes.object.isRequired,
    rate: PropTypes.object.isRequired,
    period: PropTypes.object.isRequired
};

function mapStateToProps(state) {
    return {
        tabDisplay: state.periodsReducer.tabDisplay,
        pageMode: state.periodsReducer.periodPositionsRouter.mode
    }
}

function mapDispatchToProps(dispatch) {
    return {

    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(PeriodChildContainer));